import { render, staticRenderFns } from "./LotteryPage.vue?vue&type=template&id=598aca49&scoped=true"
import script from "./LotteryPage.vue?vue&type=script&lang=js"
export * from "./LotteryPage.vue?vue&type=script&lang=js"
import style0 from "./LotteryPage.vue?vue&type=style&index=0&id=598aca49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598aca49",
  null
  
)

export default component.exports